<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>
  <div class="card">
    <div
      class="card-header bg-primary font-weight-bold text-white"
      style="display: flex; align-items: center;"
    >
      Data Peserta
      <Button
        class="btn btn-md btn-dark px-4 py-2 ml-auto text-white"
        @click="$router.go(-1)"
      >Kembali</Button>
    </div>
    <div class="card-header bg-white text-muted h4">Upload Absensi</div>
    <div class="card-body">
      <!-- Form J-CPA -->
      <div class="card border-0 shadow p-2">
        <div class="card-header bg-white text-muted h4">Sertifikasi J-CPA</div>
        <div class="card-body">
          <form>
            <div class="form-row">
              <div class="form-group col-md-4">
                <label for="kode" class="font-weight-bold">
                  Sesi 1
                  <small class="text-info">
                    <a href>(Lihat File)</a>
                  </small>
                </label>
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="validatedCustomFile"
                    @change="fileUpload"
                  />
                  <label class="custom-file-label" for="validatedCustomFile" data-browse="Unggah">{{ fileName }}.</label>
                </div>
              </div>
              <div class="form-group col-md-4">
                <label for="kode" class="font-weight-bold">
                  Sesi 2
                  <small class="text-info">
                    <a href>(Lihat File)</a>
                  </small>
                </label>
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="validatedCustomFile"
                    @change="fileUpload"
                  />
                  <label class="custom-file-label" for="validatedCustomFile" data-browse="Unggah">{{ fileName }}.</label>
                </div>
              </div>
              <div class="form-group col-md-4">
                <label for="kode" class="font-weight-bold">
                  Sesi 3
                  <small class="text-info">
                    <a href>(Lihat File)</a>
                  </small>
                </label>
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="validatedCustomFile"
                    @change="fileUpload"
                  />
                  <label class="custom-file-label" for="validatedCustomFile" data-browse="Unggah">{{ fileName }}.</label>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <!-- End Form J-CPA -->
      <!-- Form A-CPA -->
      <div class="card border-0 shadow p-2">
        <div class="card-header bg-white text-muted h4">Sertifikasi A-CPA</div>
        <div class="card-body">
          <form>
            <div class="form-row">
              <div class="form-group col-md-4">
                <label for="kode" class="font-weight-bold">
                  Sesi 1
                  <small class="text-info">
                    <a href>(Lihat File)</a>
                  </small>
                </label>
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="validatedCustomFile"
                    @change="fileUpload"
                  />
                  <label class="custom-file-label" for="validatedCustomFile" data-browse="Unggah">{{ fileName }}.</label>
                </div>
              </div>
              <div class="form-group col-md-4">
                <label for="kode" class="font-weight-bold">
                  Sesi 2
                  <small class="text-info">
                    <a href>(Lihat File)</a>
                  </small>
                </label>
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="validatedCustomFile"
                    @change="fileUpload"
                  />
                  <label class="custom-file-label" for="validatedCustomFile" data-browse="Unggah">{{ fileName }}.</label>
                </div>
              </div>
              <div class="form-group col-md-4">
                <label for="kode" class="font-weight-bold">
                  Sesi 3
                  <small class="text-info">
                    <a href>(Lihat File)</a>
                  </small>
                </label>
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="validatedCustomFile"
                    @change="fileUpload"
                  />
                  <label class="custom-file-label" for="validatedCustomFile" data-browse="Unggah">{{ fileName }}.</label>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <!-- End Form CPA -->

      <!-- Form CPA -->
      <div class="card border-0 shadow p-2">
        <div class="card-header bg-white text-muted h4">Sertifikasi CPA</div>
        <div class="card-body">
          <form>
            <div class="form-row">
              <div class="form-group col-md-4">
                <label for="kode" class="font-weight-bold">
                  Sesi 1
                  <small class="text-info">
                    <a href>(Lihat File)</a>
                  </small>
                </label>
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="validatedCustomFile"
                    @change="fileUpload"
                  />
                  <label class="custom-file-label" for="validatedCustomFile" data-browse="Unggah">{{ fileName }}.</label>
                </div>
              </div>
              <div class="form-group col-md-4">
                <label for="kode" class="font-weight-bold">
                  Sesi 2
                  <small class="text-info">
                    <a href>(Lihat File)</a>
                  </small>
                </label>
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="validatedCustomFile"
                    @change="fileUpload"
                  />
                  <label class="custom-file-label" for="validatedCustomFile" data-browse="Unggah">{{ fileName }}.</label>
                </div>
              </div>
              <div class="form-group col-md-4">
                <label for="kode" class="font-weight-bold">
                  Sesi 3
                  <small class="text-info">
                    <a href>(Lihat File)</a>
                  </small>
                </label>
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="validatedCustomFile"
                    @change="fileUpload"
                  />
                  <label class="custom-file-label" for="validatedCustomFile" data-browse="Unggah">{{ fileName }}.</label>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <!-- End Form CPA-->

      <!-- Form CPA-AP -->
      <div class="card border-0 shadow p-2">
        <div class="card-header bg-white text-muted h4">Sertifikasi CPA-AP</div>
        <div class="card-body">
          <form>
            <div class="form-row">
              <div class="form-group col-md-4">
                <label for="kode" class="font-weight-bold">
                  Sesi 1
                  <small class="text-info">
                    <a href>(Lihat File)</a>
                  </small>
                </label>
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="validatedCustomFile"
                    @change="fileUpload"
                  />
                  <label class="custom-file-label" for="validatedCustomFile" data-browse="Unggah">{{ fileName }}.</label>
                </div>
              </div>
              <div class="form-group col-md-4">
                <label for="kode" class="font-weight-bold">
                  Sesi 2
                  <small class="text-info">
                    <a href>(Lihat File)</a>
                  </small>
                </label>
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="validatedCustomFile"
                    @change="fileUpload"
                  />
                  <label class="custom-file-label" for="validatedCustomFile" data-browse="Unggah">{{ fileName }}.</label>
                </div>
              </div>
              <div class="form-group col-md-4">
                <label for="kode" class="font-weight-bold">
                  Sesi 3
                  <small class="text-info">
                    <a href>(Lihat File)</a>
                  </small>
                </label>
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="validatedCustomFile"
                    @change="fileUpload"
                  />
                  <label class="custom-file-label" for="validatedCustomFile" data-browse="Unggah">{{ fileName }}.</label>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <!-- End Form CPA-AP -->
      <!-- Form Ujian Komprehensif -->
      <div class="card border-0 shadow p-2">
        <div class="card-header bg-white text-muted h4">Sertifikasi Ujian Komprehensif</div>
        <div class="card-body">
          <form>
            <div class="form-row">
              <div class="form-group col-md-4">
                <label for="kode" class="font-weight-bold">
                  Sesi 1
                  <small class="text-info">
                    <a href>(Lihat File)</a>
                  </small>
                </label>
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="validatedCustomFile"
                    @change="fileUpload"
                  />
                  <label class="custom-file-label" for="validatedCustomFile" data-browse="Unggah">{{ fileName }}.</label>
                </div>
              </div>
              <div class="form-group col-md-4">
                <label for="kode" class="font-weight-bold">
                  Sesi 2
                  <small class="text-info">
                    <a href>(Lihat File)</a>
                  </small>
                </label>
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="validatedCustomFile"
                    @change="fileUpload"
                  />
                  <label class="custom-file-label" for="validatedCustomFile" data-browse="Unggah">{{ fileName }}.</label>
                </div>
              </div>
              <div class="form-group col-md-4">
                <label for="kode" class="font-weight-bold">
                  Sesi 3
                  <small class="text-info">
                    <a href>(Lihat File)</a>
                  </small>
                </label>
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="validatedCustomFile"
                    @change="fileUpload"
                  />
                  <label class="custom-file-label" for="validatedCustomFile" data-browse="Unggah">{{ fileName }}.</label>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <!-- End Form Ujian Komprehensif -->
    </div>
    <div class="card-footer bg-white border-0 ml-auto mb-3 mr-3">
      <!-- <router-link to="/sertifikasi/jadwal-tc/sesi-1">
        <Button class="btn btn-md btn-danger px-4 py-2 mr-3" color="danger">Tutup</Button>
      </router-link> -->
      <router-link to="/sertifikasi/jadwal-tc/sesi-1">
        <Button class="btn btn-md btn-success px-4 py-2" type="submit" color="success">Simpan</Button>
      </router-link>
    </div>
  </div>
</template>
<script>
export default {};
</script>